
const ChargingPolicy = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/ChargingPolicy.vue")
const ChargingPolicies = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/ChargingPolicies.vue")
const EquipmentProfiles = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/EquipmentProfiles.vue")
const CommissioningDetail = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/CommissioningDetail.vue")
const OrganizationSearch = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/OrganizationSearch.vue")
const OrganizationDetail = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/OrganizationDetail.vue")
const OrganizationAdd = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/OrganizationAdd.vue")
const OrganizationEdit = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationEdit.vue")
const OrganizationInformation = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationInformation.vue")
const OrganizationDashboard = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationDashboard.vue")
const OrganizationChildren = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationChildren.vue")
const OrganizationTokens = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationTokens.vue")
const OrganizationChargingPoints = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationChargingPoints.vue")
const OrganizationCustomers = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationCustomers.vue")
const OrganizationInvoices = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationInvoices.vue")
const OrganizationPaymentMethods = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationPaymentMethods.vue")
const PaymentMethodsOutbound = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/PaymentMethod/PaymentMethodsOutbound.vue")
const PaymentMethodsInbound = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/PaymentMethod/PaymentMethodsInbound.vue")
const OrganizationTransactions = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationTransactions.vue")

const OrganizationDetailSessionAuthorizations = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationDetailSessionAuthorizations.vue")
const OrganizationMembers = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationMembers.vue")

const MemberInvitationSearch = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/Member/MemberInvitationSearch.vue")
const RegistrationDetail = () => import(/* webpackChunkName: "onboarding" */ "@pages/Onboarding/RegistrationDetail.vue")
const MemberInvitationDetail = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/Invitation/MemberInvitationDetail.vue")

const MemberTypeSearch = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/Member/MemberTypeSearch.vue")
const MemberTypeForm = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/Member/MemberTypeForm.vue")

const MeterDeviceReadings = () => import(/* webpackChunkName: "price-index" */ "@pages/MeterDevice/Detail/MeterDeviceReadings.vue")

const MemberGroupSearch = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/Member/MemberGroupSearch.vue")
const MemberGroupForm = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/Member/MemberGroupForm.vue")
const OrganizationTariffs = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationTariffs.vue")
const OrganizationUsages = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationUsages.vue")
const OrganizationPendingOrders = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationPendingOrders.vue")
const OrganizationUsers = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationUsers.vue")
const OrganizationSubscriptions = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationSubscriptions.vue")
const OrganizationSubscriptionEdit = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/Subscription/OrganizationSubscriptionEdit.vue")
const OrganizationExpensePeriods = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationExpensePeriods.vue")
const ExpensePeriodMembers = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/ExpenseRefund/ExpensePeriodMembers.vue")
const ExpensePeriodMember = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/ExpenseRefund/ExpensePeriodMember.vue")

const OrganizationSubscriptionLicences = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/Subscription/OrganizationSubscriptionLicences.vue")


const OrganizationEnergyProvider = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationEnergyProvider.vue")

const EnergyProviderPeriod = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/EnergyProvider/EnergyProviderPeriod.vue")
const EnergyProviderPeriodLines = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/EnergyProvider/EnergyProviderPeriodLines.vue")

const PaymentOnboardingRelay = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/PaymentOnboardingRelay.vue")

const CostCenterAttribution = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/CostCenter/CostCenterAttribution.vue")
const OrganizationVehicles = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationVehicles.vue")
const OrganizationSSO = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationSSO.vue")
const OrganizationSettings = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationSettings.vue")
const OrganizationLocations = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationLocations.vue")
const OrganizationPdls = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationPdls.vue")
const OrganizationBillingRequests = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationBillingRequests.vue")
const OrganizationMeterDevices = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationMeterDevices.vue")
const OrganizationBillingInfo = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationBillingInfo.vue")
const OrganizationRoamingConfig = () => import(/* webpackChunkName: "organization" */ "@pages/Organization/Detail/OrganizationRoamingConfig.vue")

export default [
  {
    name: 'organizations.search',
    path: 'organizations',
    component: OrganizationSearch,
    meta: {
      auth: true,
    },
  },

  {
    name: 'organizations.add',
    path: 'organizations/add',
    component: OrganizationAdd,
    meta: {
      auth: true,
    },
  },
    {
        name: 'organizations.payment-onboarding',
        path: 'organizations/:id/payment-onboarding',
        component: PaymentOnboardingRelay,
    },


  {
    path: 'organizations/:id',
    component: OrganizationDetail,
    children: [
      {
        path: '',
        name: 'organizations.detail',
        component: OrganizationInformation,
      },
      {
        path: 'dashboard',
        name: 'organizations.dashboard',
        component: OrganizationDashboard,
      },
      {
        name: 'organizations.edit',
        path: 'edit',
        component: OrganizationEdit,
      },
      {
        name: 'organizations.charging-points',
        path: 'charging-points',
        component: OrganizationChargingPoints,
      },

      {
        name: 'organizations.customers',
        path: 'customers',
        component: OrganizationCustomers,
      },
      {
        name: 'organizations.members',
        path: 'members',
        component: OrganizationMembers,
      },
      {
        name: 'organizations.charging-policies',
        path: 'charging-policies',
        component: ChargingPolicies,
      },
      {
        name: 'organizations.charging-policy',
        path: 'charging-policies/:policyId',
        component: ChargingPolicy,
      },
      {
        name: 'organizations.equipment-profiles',
        path: 'equipment-profiles',
        component: EquipmentProfiles,
      },
      // Les anciennes adresses (une seule politique, « Politique d'onboarding », l'écran « Inscription »).
      { path: 'charging-policy', redirect: { name: 'organizations.charging-policies' } },
      { path: 'onboarding-policy', redirect: { name: 'organizations.charging-policies' } },
      { path: 'onboarding-configuration', redirect: { name: 'organizations.charging-policies' } },

      {
        name: 'organizations.members.registration',
        path: 'members/registrations/:registrationId',
        component: RegistrationDetail,
      },

      {
        name: 'organizations.members.invitations.manage',
        path: 'members/invitations/manage/:invitationId',
        component: MemberInvitationDetail,
      },

      {
        name: 'organizations.pending-orders',
        path: 'pending-orders',
        component: OrganizationPendingOrders,
      },
      // Une commande d'équipement, ouverte sans quitter la fiche de l'organisation.
      {
        name: 'organizations.equipment-order',
        path: 'equipment-orders/:orderId',
        component: CommissioningDetail,
        props: route => ({ orderId: route.params.orderId }),
      },

      {
        name: 'organizations.members.invitations',
        path: 'members/invitations',
        component: MemberInvitationSearch,
      },
      {
        name: 'organizations.members.types',
        path: 'members/types',
        component: MemberTypeSearch,
      },
      {
        name: 'organizations.members.types.add',
        path: 'members/types/add',
        component: MemberTypeForm,
      },
      {
        name: 'organizations.members.types.edit',
        path: 'members/types/:memberTypeId/edit',
        component: MemberTypeForm,
      },

      {
        name: 'organizations.members.groups',
        path: 'members/groups',
        component: MemberGroupSearch,
      },
      {
        name: 'organizations.members.groups.add',
        path: 'members/groups/add',
        component: MemberGroupForm,
      },
      {
        name: 'organizations.members.groups.edit',
        path: 'members/groups/:memberGroupId/edit',
        component: MemberGroupForm,
      },
      {
        name: 'organizations.tariffs',
        path: 'tariffs',
        component: OrganizationTariffs,
      },
      {
        name: 'organizations.invoices',
        path: 'invoices',
        component: OrganizationInvoices,
      },
      {
        path: 'payment-methods',
        component: OrganizationPaymentMethods,
        children: [
            {
                path: '',
                name: 'organizations.payment-methods',
                component: PaymentMethodsInbound,
            },
            {
                path: 'payout',
                name: 'organizations.payout',
                component: PaymentMethodsOutbound,
            },
        ]
      },
      {
        path: 'transactions',
        name: 'organizations.transactions',
        component: OrganizationTransactions,
      },
      {
        name: 'organizations.authorizations',
        path: 'authorizations',
        component: OrganizationDetailSessionAuthorizations,
      },
      {
        name: 'organizations.usages',
        path: 'usages',
        component: OrganizationUsages,
      },
      {
        name: 'organizations.meter-devices-readings',
        path: 'meter-device-readings',
        component: MeterDeviceReadings,
      },
      {
        name: 'organizations.children',
        path: 'children',
        component: OrganizationChildren,
      },
      {
        name: 'organizations.tokens',
        path: 'tokens',
        component: OrganizationTokens,
      },
      {
        name: 'organizations.users',
        path: 'users',
        component: OrganizationUsers,
      },
      {
        name: 'organizations.subscriptions',
        path: 'subscriptions',
        component: OrganizationSubscriptions,
      },
      {
        name: 'organizations.subscriptions.edit',
        path: 'subscriptions/edit/:subscriptionId',
        component: OrganizationSubscriptionEdit,
      },
      {
        name: 'organizations.subscriptions.licences',
        path: 'subscriptions/:subscriptionId/licences',
        component: OrganizationSubscriptionLicences,
      },
      {
        name: 'organizations.expense-periods',
        path: 'expense-periods',
        component: OrganizationExpensePeriods,
      },
      {
        name: 'organizations.expense-periods.manage',
        path: 'expense-periods/:periodId',
        component: ExpensePeriodMembers,
      },
      {
        name: 'organizations.expense-periods.member',
        path: 'expense-periods/:periodId/:memberId',
        component: ExpensePeriodMember,
      },
      {
        name: 'organizations.energy-provider',
        path: 'recharge-service',
        component: OrganizationEnergyProvider,
      },
      {
        name: 'organizations.energy-provider.period',
        path: 'recharge-service/:periodId',
        component: EnergyProviderPeriod
      },
      {
        name: 'organizations.energy-provider.period.lines',
        path: 'recharge-service/:periodId/lines',
        component: EnergyProviderPeriodLines,
      },
      {
        name: 'organizations.detail.cost-centers',
        path: 'cost-centers',
        component: CostCenterAttribution,
      },
      {
        name: 'organizations.vehicles',
        path: 'vehicles',
        component: OrganizationVehicles,
      },
      {
        name: 'organizations.sso',
        path: 'sso',
        component: OrganizationSSO,
      },
      {
        name: 'organizations.sso.edit',
        path: 'sso/:idpId',
        component: OrganizationSSO,
      },
      {
        name: 'organizations.settings',
        path: 'settings',
        component: OrganizationSettings,
      },
      {
        name: 'organizations.locations',
        path: 'locations',
        component: OrganizationLocations,
      },
      {
        name: 'organizations.pdls',
        path: 'pdls',
        component: OrganizationPdls,
      },
      {
        name: 'organizations.meter-devices',
        path: 'meter-devices',
        component: OrganizationMeterDevices,
      },
      {
        name: 'organizations.billing-requests',
        path: 'billing-requests',
        component: OrganizationBillingRequests,
      },
      {
        name: 'organizations.billing-info',
        path: 'billing-info',
        component: OrganizationBillingInfo,
      },
      {
        name: 'organizations.roaming-config',
        path: 'roaming-config',
        component: OrganizationRoamingConfig,
      },
    ],
},
]
